declare var Modernizr;

export default function (): boolean {
    return window.innerWidth <= 640 || ((typeof(Modernizr) === "undefined" ? false : Modernizr.touchevents) && window.innerWidth <= 1024);

}

export function isPad(): boolean {
    try {
        return window.innerWidth <= 640 || ((typeof(Modernizr) === "undefined" ? false : Modernizr.touchevents) && window.innerWidth < 768);
    } catch (ex) {
        return false;
    }
}

export function isPhone(): boolean {
    return window.innerWidth <= 640 || ((typeof(Modernizr) === "undefined" ? false : Modernizr.touchevents) && window.innerWidth < 768);
}

export function isBelowSidebarWidth(): boolean {
    // Value is taken from the $sidebar-swap variable in the CSS -- functionality changes at that size
    const sidebarSwapMediaQuery = window.matchMedia("(max-width: 930px)");
    console.log(sidebarSwapMediaQuery);
    return sidebarSwapMediaQuery.matches;
}